<template lang="html">
  <div class="rear-content">
    <div class="rear-content-inner" v-if="workerInfo && workerInfo.uid">
      <header class="header">
        <div class="userInfo">
          <div class="container">
            <div class="user">
              <div class="headImg">
                <img :src="workerInfo.headImage | avatarAdvi(220, 220)" />
              </div>
              <div class="info">
                <div class="first">
                  <div>
                    <span class="name">
                      {{ workerInfo.workerName }}
                    </span>
                    <span class="job">
                      {{ workerInfo.userTypeName || '育儿顾问' }}
                    </span>
                  </div>
                  <img class="qrcode" :src="qrcodeLittle" @click="toScanMe" />
                </div>
                <div class="second">
                  <span class="year" v-if="workerInfo.workAge">
                    从业{{ workerInfo.workAge }}年
                  </span>
                  <span class="store" @click="toShopp">
                    {{ workerInfo.storeName }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="profile-wrap"
            v-if="workerInfo.consultationTime || workerInfo.introduce"
          >
            <p class="txt" v-if="workerInfo.consultationTime">
              咨询时间：{{ workerInfo.consultationTime }}
            </p>
            <div v-if="workerInfo.introduce">
              <p
                class="txt"
                v-model="shortProfile"
                :class="{ 'ui-nowrap-multi': profileArr.isLong }"
              >
                {{ workerInfo.introduce }}
              </p>
              <a
                class="btn"
                v-if="profileArr.isShow"
                :class="{ active: profileArr.isActive }"
                @click="profileFn()"
                ><i class="iconfont icon-xiajiantou"></i
              ></a>
            </div>
          </div>
          <div class="profile-wrap-empty" v-else></div>
        </div>
      </header>
      <section
        class="box certifiedInfo"
        v-if="
          workerInfo.workerCredentials &&
          workerInfo.workerCredentials.length > 0
        "
      >
        <h2>专业认证</h2>
        <div class="list">
          <span
            v-for="item in workerInfo.workerCredentials"
            class="part"
            @click="toCredential(item.name)"
          >
            <i class="icon"></i>{{ item.name }}
          </span>
        </div>
      </section>
      <serviceList
        v-if="userInfo.spuList && userInfo.spuList.length"
        :list="userInfo.spuList"
        :empId="workerInfo.workerCode"
      />
      <section
        class="box guw-ui"
        v-if="userInfo.picUrls && userInfo.picUrls.length"
      >
        <h2>顾问风采</h2>
        <div class="g-info">
          <ul :style="schedualWaresShow">
            <li
              v-for="(item, i) in userInfo.picUrls"
              @click="showImage(userInfo.picUrls, i)"
            >
              <img :src="$$viewImageInCenter(item, 300, 300)" />
            </li>
          </ul>
        </div>
      </section>
      <div
        class="g-section member-evaluate-section box noPadding"
        v-if="memberComment && memberComment.total > 0"
      >
        <commentEnter
          :commentData="memberComment"
          :id="workerInfo.workerCode"
          :uid="uid"
          toAllComment="adviser"
        ></commentEnter>
      </div>
    </div>
    <div class="footer" v-if="ispauid">
      <span class="setPauid" v-if="pauid == workerInfo.uid"
        >她是您的专属育儿顾问</span
      >
      <span class="setPauid" @click="setMyPauid" v-else
        >设为我的专属育儿顾问</span
      >
    </div>
    <template v-else>
      <actionbar v-if="isCzjApp">
        <button class="btns btn-pink" slot="buttons">
          <a
            class="ui-border-r btn pingjia"
            :href="`/v/evaluate?workerUid=${workerInfo.uid}&ht=add&cmd=share&sharetype=0&refresh=no`"
          >
            <span>评价</span>
          </a>
        </button>
      </actionbar>
      <actionbar v-else class="rearAction">
        <li slot="icons">
          <!-- <a class="ui-border-r btn pingjia" :href="`/v/user/${workerInfo.uid}/comment/add`" @click="trackClick(200003, '点击评价')"> -->
          <a
            class="ui-border-r btn pingjia"
            :href="`/v/evaluate?workerUid=${workerInfo.uid}&ht=add&cmd=share&sharetype=0&refresh=no`"
            @click="trackClick(200003, '点击评价')"
          >
            <i class="pingjia"></i><span>评价</span>
          </a>
        </li>
        <button
          v-if="staffInfo.isWxFriend"
          class="btns btn-gray_b btn-round contact-wx"
          slot="buttons"
        >
          <a class="ui-border-r" href="javascript:;" @click="toWx">微信联系</a>
        </button>
        <button
          v-else
          class="btns btn-gray_b btn-round contact-wx"
          slot="buttons"
        >
          <a class="ui-border-r" href="javascript:;" @click="addTa">加TA好友</a>
        </button>
        <button class="btns btn-pink btn-round consult" slot="buttons">
          <a
            class="ui-border-r"
            :href="`http://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${workerInfo.uid}`"
            @click="toIM($event)"
            >在线咨询</a
          >
        </button>
      </actionbar>
    </template>
    <empty
      v-else
      v-show="!firstFetch"
      :image="require('../../assets/images/empty1.png')"
      text="未找到相关信息"
    ></empty>
    <imagePreview :items="previewImages"></imagePreview>
    <van-popup v-model="qrcodeVisible" class="qrcode-visible">
      <div class="qrcode-preivew">
        <img :src="staffInfo.staffQrCode" />
        <div class="qrcode-name">{{ staffInfo.staffName }}</div>
        <div class="qrcode-tip">扫一扫上面的二维码图案，加她微信</div>
      </div>
      <!-- <img class="icon-close" src="../../assets/images/icon-delete@3x.png" @click="qrcodeVisible=false"> -->
      <img
        class="icon-close"
        src="../../assets/images/icon-delete-square@3x.png"
        @click="qrcodeVisible = false"
      />
    </van-popup>
    <!--不要删除,兼容iponex -->
    <div class="menu_wkBox_back_box"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { get } from 'lodash'
// import star from '@/components/common/star2020'
// import commentItem from '@/components/rear/item'
// import postItem from '@/components/rear/item-experience'
import imagePreview from '@/components/common/viewImage'
import orderTime from '@/components/rear/order-time'
import datePrompt from '@/components/date/prompt'
import empty from '@/components/common/empty'
import actionbar from '@/components/order/actionbar'
import qaList from '@/components/rear/qaList'
// import shoppingList from '@/components/rear/shoppingList'
import scrollerList from '@/components/rear/scrollerList'
import serviceList from '@/components/rear/personalServiceList'
// import addIm from '@/components/common/im'
// import statisticsIcons from './statisticsIcons'
import qrcodeLittle from '@/assets/images/icon-qrcode@3x.png'
import commentEnter from '@/components/newComment/commentEnter'
// import isIOS from '@/plugins/isIOS'
import { appLaunchMp, appCopyText, appOpenWx } from '@/utils'
import { Popup } from 'vant'

export default {
  PAGE_ID: '121011912',
  data() {
    return {
      // isIOS,
      fuid: '',
      uid: null,
      attrsTxt: [],
      credentialsNameArr: [],
      profileArr: {
        isLong: false,
        isShow: false,
        isActive: false
      },
      schedualAreasStr: [],
      schedualWaresShow: {
        width: '100%'
      },
      moveX: 0,
      pageX: null,
      evaluateLis: [],
      evaluateLisNum: null,
      firstFetch: false,
      shequUserInfo: { is_follow: false, comment_num: 0, fans_num: 0 },
      // is_follow: false,
      show_follow_relation: false,
      memberComment: {},
      experience: {},
      signList: [],
      answerList: [],
      ispauid: false,
      pauid: '',
      // shoppingList: {},
      default_pic: require('../../assets/images/default_yegw_bg.jpg'),
      default_avator: require('../../assets/images/default_yegw_avator.png'),
      groupId: '',
      qrcodeLittle,
      staffInfo: {},
      qrcodeVisible: false
    }
  },
  async created() {
    this.trackView()
    this.trackBT(121012451)()
    this.fuid = this.$$cookie('uid') || ''
    this.uid = this.$route.params.uid || this.$$cookie('uid')
    this.ispauid = this.$route.query.ispauid || false
    this.pauid = this.$route.query.pauid || ''
    this.getUserInfoFromShequ()
    this.getStaffInfo()
    this.getAnswers()
    if (this.ispauid || this.ispauid === 'true') {
      this.getUserInfoFromUser()
    }
    this.$$loading(false)
    const name = this.workerInfo.workerName
    const genius = this.workerInfo.workCategorys
      .map(ele => ele.service_name)
      .join('、')
    const desc = `孩子王育儿服务平台${this.workerInfo.workerName}为您提供专业服务，擅长${genius}`
    const shareRemark = {
      // https://doc.weixin.qq.com/sheet/e3_AHcAFgYQAOQ5JzaHs1ySymwTlnHNW
      // toolType
      // 401	服务分享赚
      // 402	心愿单
      // 403	代客下单
      // --------------
      // contentType\contentId
      // 201	服务商祥	SPUID
      // 202	服务拼团商祥	SKUID
      // 203	服务景区详情	SPUID
      // 204	服务频道页	CHANNEL_ID
      // 205	服务天天特价频道页
      // 206	服务晒图有奖
      // 207	服务店铺	BUSINESSID
      // 208	服务人格化主页	WORKERID
      // toolType,
      // toolCode,
      url: encodeURIComponent(location.href),
      contentType: 208,
      contentId: this.workerInfo.uid || ''
      // storeCode,
      // groupId,
      // phoneNumber
    }

    this.$$share({
      link: `https://life.cekid.com/v/user/${this.uid}`,
      desc,
      title: `育儿顾问${name}的名片`,
      imgUrl: this.workerInfo.headImage,
      remark: JSON.stringify(shareRemark)
    })
    const shareInfo = {
      title: `育儿顾问${name}`,
      desc: '孩子王，中国新家庭全渠道服务商！',
      link: `https://life.cekid.com/v/user/${this.uid}`,
      imgUrl: this.workerInfo.headImage
    }
    window.getImInfo = () => shareInfo
    this.$$title(`育儿顾问${name}`)
  },
  async mounted() {
    try {
      // this.getShoppingList()
      this.getMemberEvaluate()
      if (!this.isCzjApp) {
        this.getExperience()
      }
      // this.getSignListByCode()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    async getUserInfoFromUser() {
      const res = await this.$store.dispatch('getUserInfoFromUser', {
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey'),
        padetail: 1
      })
      // console.log(res);
      if (res.uid && res.pauid) {
        this.pauid = res.pauid
      }
    },
    showImage(images, index) {
      // const arr = images.map(img => img.downloadurl)
      this.$store.commit('setPreviewImages', images)
      this.$router.push({ query: { preview: true, index } })
    },
    serviceDisplay(attr) {
      if (attr) {
        const attr_names = attr.map(ele => ele.service_name)
        return attr_names.join('、') || '暂未开通服务'
      }
      return '暂未开通服务'
    },
    async getAnswers() {
      const res = await this.$store.dispatch('getAnswers', {
        uid: this.workerInfo.uid
      })
      if (res.code === 1001) {
        this.answerList = res.data || []
      }
    },
    async getUserInfoFromShequ() {
      const user_shequ = await this.$store.dispatch('getUserInfoFromShequ', {
        // uid: this.$$cookie('uid'),
        to_uid: this.uid
      })
      const plus = await this.$store.dispatch('getUserInfoPlusFromShequ', {
        to_uid: this.uid
      })
      this.show_follow_relation = true
      if (user_shequ.code === 1001) {
        this.shequUserInfo.is_follow = user_shequ.data.is_follow
        this.shequUserInfo.fans_num = user_shequ.data.fans_num
      }
      if (plus.code === 1001) {
        this.shequUserInfo.comment_num = plus.data.comment_num
      }
    },
    async getStaffInfo() {
      const staffDetail = await this.$store.dispatch('getStaffDetail', {
        uid: this.$$cookie('uid'),
        to_uid: this.workerInfo.workerCode,
        skey: this.$$cookie('skey')
      })
      this.staffInfo = get(
        staffDetail,
        'content.result.rmdlist[0].data.staffInfo',
        {}
      )
    },
    profileFn() {
      if (this.profileArr.isLong) {
        this.profileArr.isLong = false
        this.profileArr.isActive = true
      } else {
        this.profileArr.isLong = true
        this.profileArr.isActive = false
      }
    },
    serviceShowTrigger(e) {
      const iel = e.currentTarget.querySelector('i')
      iel.classList.toggle('rotate')
      document
        .querySelector('.service-part li.addborder')
        .classList.toggle('withborder')
      const els = [...document.querySelectorAll('.service-part li.needHide')]
      els.forEach(el => {
        el.classList.toggle('hide')
      })
    },
    async getEvaluate() {
      try {
        const extendStr = JSON.stringify({
          community: this.uid
        })
        const evaluatelist = await this.$store.dispatch('getEvaluatePage', {
          extend: extendStr,
          page: 1,
          size: 2,
          show_user: 1,
          show_reply: 1
        })
        if (evaluatelist.code === 1001) {
          this.evaluateLis = evaluatelist.data.list
          this.evaluateLisNum = evaluatelist.data.count
        } else {
          this.$$toast({
            message: evaluatelist.message
          })
        }
      } catch (e) {
        // this.hasErr = true
      }
    },
    async toScanMe() {
      this.trackClick(200002, '点击二维码')
      await this.$$ensureLogin()
      this.qrcodeVisible = true
      // if (this.$$isHZWApp()) {
      //     location.href = `https://shequ.cekid.com/update.html?cmd=sqqrcode&uid=${this.uid}&nickname=${encodeURIComponent(this.workerInfo.workerName)}&usertype=1`
      // } else {
      //     location.href = `https://party.cekid.com/entry/app/v1.html?cmd=sqqrcode&uid=${this.uid}&nickname=${encodeURIComponent(this.workerInfo.workerName)}&usertype=1`
      // }
    },
    toQa() {
      location.href = `//shequ.cekid.com/bbs/user/${this.uid}/qa?cmd=sqwd_person_answer&uid=${this.uid}&nickname=${this.workerInfo.workerName}`
    },
    toShopp() {
      if (this.isCzjApp) return
      location.href = `//w.cekid.com/store/?code=${this.workerInfo.storeCode}`
    },
    toPay($event) {
      $event.preventDefault()
      if (this.$$isRkhy()) {
        window.location = '//shequ.cekid.com/dynamic/yegw/update.html'
      } else {
        window.location = `//shequ.cekid.com/dynamic/yegw/pay.html?uid=${this.workerInfo.uid}`
      }
    },
    toIM($event) {
      $event.preventDefault()
      this.trackClick(
        200001,
        { fuid: this.fuid },
        `fuid: ${this.fuid}`,
        121011912
      )
      if (this.$$isHZWApp() || this.$$isRkhy()) {
        if (this.workerInfo.userType === 1) {
          window.location = `//im.cekid.com/shequ/chat/?targetId=${this.workerInfo.uid} &cmd=imconversation&scenetype=11&userid=${this.workerInfo.uid}&refresh=no`
        } else {
          window.location.href = event.currentTarget.getAttribute('href')
        }
      } else {
        window.location.href = event.currentTarget.getAttribute('href')
      }
    },
    /* 添加企微好友 */
    async addTa() {
      if (this.$$isHZWApp()) {
        await this.$$ensureLogin()
        const staffCode = this.staffInfo.staffCode || this.workerInfo.workerCode
        let link = `/server-pages/pages/service-transfer/index?staffcode=${staffCode}&contacttype=1&business=topcontacts`
        appLaunchMp(link, 0)
      } else {
        location.href = `https://party.cekid.com/entry/app/v3.html`
      }
    },
    /* 跳转微信联系 */
    toWx() {
      if (this.$$isHZWApp()) {
        // 复制姓名
        appCopyText(this.staffInfo.staffName)
        // 拉起微信
        setTimeout(() => {
          appOpenWx()
        }, '4000')
      } else {
        location.href = `https://party.cekid.com/entry/app/v3.html`
      }
    },
    toUserHome(index, uid) {
      location.href = `/v/user/${uid}`
    },
    async follow() {
      this.trackClick(200005, '点击加为好友')
      const follow_res = await this.$store.dispatch('doFollow', {
        follow_id: this.uid
      })
      if (follow_res && follow_res.code === 1001) {
        this.shequUserInfo.is_follow = true
        const ele_toast = [...document.querySelectorAll('.cekid-toast')]
        if (ele_toast && ele_toast.length > 0) {
          ele_toast.forEach(ele => {
            if (ele.parentNode) {
              ele.parentNode.removeChild(ele)
            }
          })
        }
        this.$$toast('已加好友，可在通讯录中查看')
      } else if (follow_res.code === 1005) {
        this.$$login()
      }
    },
    async unfollow() {
      const follow_res = await this.$store.dispatch('deleteFollow', {
        follow_id: this.uid
      })
      if (follow_res && follow_res.code === 1001) {
        this.shequUserInfo.is_follow = false
        const ele_toast = [...document.querySelectorAll('.cekid-toast')]
        if (ele_toast && ele_toast.length > 0) {
          ele_toast.forEach(ele => {
            if (ele.parentNode) {
              ele.parentNode.removeChild(ele)
            }
          })
        }
        // this.$$toast('取消关注成功')
      } else if (follow_res.code === 1005) {
        this.$$login()
      }
    },
    async getMemberEvaluate() {
      const comment = await this.$store.dispatch('getNewCommentList', {
        page: 1,
        size: 2,
        workerCode: this.workerInfo.workerCode,
        type: 99,
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey'),
        property: 2 // 短评
      })
      console.log(282828, comment)
      if (+comment.code === 1) {
        this.memberComment = comment.data
      } else {
        this.$$toast({
          message: comment.msg
        })
      }
    },
    toExperience(num) {
      location.href = `//shequ.cekid.com/bbs/user/${this.workerInfo.uid}?cmd=usercard&userType=0&userid=${this.workerInfo.uid}&user=true`
    },
    async getExperience() {
      const exp = await this.$store.dispatch('getBBSList', {
        to_uid: this.uid,
        limit_num: 1
      })
      if (exp.code === 1001) {
        this.experience = exp.data
      }
    },
    async setMyPauid() {
      try {
        const { uid, skey } = await this.$$ensureLogin()
        const pauid = this.workerInfo.uid
        const source = 1
        const json = await this.$store.dispatch('setModifyBasicUserInfo', {
          uid,
          skey,
          pauid,
          source
        })
        if (json && json.errno === 0) {
          this.$$toast(json.errmsg || '设置成功')
          this.pauid = pauid
        } else if (json && json.errno === 1024) {
          this.$$login()
        } else {
          this.$$toast(json.errmsg || '系统异常，稍后再试')
        }
      } catch (e) {
        console.log(e)
      }
    },
    toCredential(name) {
      if (name === '营业执照') {
        location.href = `/v/user/${this.workerInfo.uid}/licence?cmd=share&sharetype=0&userType=1`
      }
    }
  },
  components: {
    // star,
    // commentItem,
    imagePreview,
    orderTime,
    datePrompt,
    empty,
    actionbar,
    // postItem,
    qaList,
    // shoppingList,
    scrollerList,
    serviceList,
    // addIm,
    // statisticsIcons
    commentEnter,
    [Popup.name]: Popup
  },
  computed: {
    ...mapState(['userInfo', 'previewImages']),
    workerInfo() {
      return this.userInfo.worker
    },
    commentScaleNum() {
      return this.userInfo.userCommentScale * 100
    },
    // bgimg() {
    //     return this.$$viewImageInCenter('https://hzwimspic-1251601690.picsh.myqcloud.com/4fc4d140-56a6-11ea-a92c-d30c8fbccdfb_size_750x300', 750, 300)
    //     // return this.$$viewImageInCenter(this.workerInfo.headImage || this.default_pic, 750, 554);
    // },
    startLevelNum() {
      return this.workerInfo.starLevel * 2
    },
    shortProfile() {
      if (this.workerInfo.introduce && this.workerInfo.introduce.length > 45) {
        this.profileArr.isLong = true
        this.profileArr.isShow = true
      }
    },
    oneAnswers() {
      if (this.answerList.length > 0) {
        return this.answerList.slice(0, 1)
      } else {
        return this.answerList
      }
    },
    isCzjApp() {
      return this.$$isCZJApp()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.rear-content {
  overflow-x: hidden;
  .rear-content-inner {
    margin-bottom: rem(140px);
  }
  header {
    padding-top: rem(100px);
    width: 100%;
    position: relative;
    background: url('~@/assets/images/adviser_parent_head_bg@3x.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    .focus-bt {
      position: absolute;
      left: rem(585px);
      top: rem(30px);
      width: rem(140px);
      height: rem(50px);

      .follow-trigger {
        opacity: 0.9;
        height: rem(50px);
        width: rem(140px);
        line-height: rem(50px);
        background: #ff397e;
        color: #fff;
        font-size: rem(28px);
        border-radius: rem(20px);
        text-align: center;
        @include border(all, #ff397e, 1px, 20px);

        .icon-jia {
          font-size: rem(28px);
          margin-right: rem(10px);
          font-weight: bold;
        }
      }

      .hasFocus {
        background: #fff;
        color: #666;
        @include border(all, #dfdfdf, 1px, 20px);
      }
    }
    .userInfo {
      margin: 0 rem(24px);
      padding-bottom: rem(20px);
      box-shadow: 0 rem(20px) rem(14px) rem(-12px) rgba(0, 0, 0, 0.02);
      border-radius: rem(8px);
      background-image: linear-gradient(
        0deg,
        #fcfcfc 78%,
        rgba(255, 255, 255, 0.9) 100%
      );
      width: rem(702px);
      // height: rem(348px);
      .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 rem(39px) 0 rem(26px);
      }
      .user {
        display: flex;
        align-items: center;
        width: 100%;
        .headImg {
          margin-top: rem(-24px);
          margin-right: rem(26px);
          width: rem(188px);
          height: rem(188px);
          background-color: #fff;
          padding: rem(4px);
          border-radius: 100%;
          flex: none;
          img {
            width: 100%;
            height: 100%;
            border-radius: 100%;
          }
        }
        .info {
          flex: auto;
          overflow: hidden;
        }
        .first {
          display: flex;
          align-items: center;
          justify-content: space-between;
          & > div {
            display: flex;
            align-items: center;
          }
          .name {
            margin-right: rem(18px);
            font-size: rem(36px);
            color: #000;
            text-align: center;
            line-height: normal;
            font-weight: bold;
            flex: none;
          }
          .job {
            display: block;
            padding: 0 5px;
            height: 14px;
            line-height: 15px;
            font-size: 11px;
            color: #ff397e;
            letter-spacing: 0;
            @include border(all, #ff397e, 1px, 14px);
          }
        }
        .second {
          margin-top: rem(14px);
          font-size: rem(24px);
          color: #666666;
          line-height: rem(30px);
          display: flex;
          width: 100%;
          .store {
            //border-radius: rem(8px);
            position: relative;
            padding-left: rem(12px);
            flex: auto;
            @include ellicpsis;
          }
          .year {
            position: relative;
            padding-right: rem(12px);
            flex: none;
            &:after {
              content: '';
              position: absolute;
              right: 0;
              top: 10%;
              bottom: 10%;
              width: 1px;
              background-color: #ddd;
            }
          }
        }
      }
      .qrcode {
        width: rem(40px);
        height: rem(40px);
      }
    }
    .profile-wrap {
      margin: rem(10px) rem(40px);
      font-size: rem(26px);
      color: #666666;
      letter-spacing: rem(0.93px);
      line-height: rem(42px);
      .txt {
        line-height: rem(42px);
      }
      .btn {
        display: block;
        margin-bottom: rem(-16px);
        text-align: center;
        transition: all 200ms;
        i {
          color: #999999;
        }
      }
      .active {
        transform: rotate(-180deg);
      }
      .iconfont {
        font-size: rem(24px);
      }
    }
    .profile-wrap-empty {
      padding-bottom: rem(30px);
    }
  }

  .block-part {
    background-color: #fff;
    // position:relative;
    margin-bottom: rem(20px);
    .small-block {
      display: flex;
      align-items: center;
      height: rem(132px);

      a {
        display: block;
        // padding-bottom: rem(20px);
        .txt {
          // padding-top: rem(16px);
        }
      }
      li {
        flex: 1;
        // height:rem(132px);
        .title {
          display: block;
          color: #999999;
          font-size: rem(24px);
          text-align: center;
        }
        .txt {
          display: block;
          color: #121212;
          font-size: rem(24px);
          text-align: center;
          i {
            font-size: rem(36px);
          }
        }
        .score {
          margin: rem(32px) auto rem(12px);
          padding-left: 0;
          width: rem(160px);
          display: block;
          overflow: hidden;
        }
      }
    }
  }
  .box {
    margin: rem(24px);
    padding: rem(30px) rem(30px) rem(15px);
    background: #fff;
    box-shadow: 0 rem(20px) rem(14px) rem(-12px) rgba(0, 0, 0, 0.02);
    border-radius: rem(8px);
    h2 {
      font-size: rem(34px);
      color: #121212;
      line-height: rem(40px);
      font-weight: bold;
    }
    .g-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: rem(30px);
      background: #fff;
      > h2 {
        font-weight: 700;
        font-size: rem(34px);
        color: #121212;
        line-height: rem(42px);
        > span {
          color: #999;
          font-size: rem(28px);
          font-weight: normal;
        }
        .number {
          font-size: rem(24px);
          color: #262626;
          line-height: rem(30px);
          font-weight: 700;
          margin-left: rem(12px);
        }
      }
      a {
        align-self: flex-start;
        line-height: rem(40px);
      }
      .more {
        display: flex;
        align-items: center;
        font-size: rem(24px);
        color: #262626;
        line-height: rem(30px);
      }
      .moreIcon {
        margin-left: rem(10px);
        width: rem(20px);
        height: rem(20px);
        background: url('../../assets/images/comment/icon-more.png') no-repeat
          center center;
        background-size: 100% 100%;
      }
    }
    .g-info {
      margin-top: rem(30px);
      width: 100%;
      overflow-y: auto;
      &.comment-info {
        margin-top: rem(-30px);
        .comment-item:last-child {
          padding-bottom: rem(15px);
        }
      }
      ul {
        height: rem(210px);
        display: -webkit-box;
        li {
          width: rem(180px);
          height: rem(180px);
          box-sizing: border-box;
          margin-right: rem(20px);
          padding-bottom: rem(30px);
          overflow: hidden;
          position: relative;
          z-index: 2;
          border-radius: 0.04rem;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .to-all-comment {
    display: block;
    height: rem(60px);
    width: rem(208px);
    margin: 0 auto rem(20px);
    @include border(all, #cccccc, 1px, 30px);
    border-radius: rem(30px);
    font-size: rem(24px);
    color: #262626;
    text-align: center;
    line-height: rem(60px);
  }
  .certifiedInfo {
    .list {
      display: flex;

      flex-wrap: wrap;
      margin-top: rem(29px);
      font-size: rem(26px);
      color: #333333;
      letter-spacing: 0;
      line-height: rem(32px);
      .part {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-bottom: rem(15px);
        padding-right: rem(48px);
        &:last-child {
          padding-right: 0;
        }
        .iconfont {
          margin-right: rem(10px);
          color: #ff6ea1;
        }
        i.icon {
          display: block;
          width: rem(34px);
          height: rem(32px);
          background: url('~@/assets/images/icon-auth@3x.png') no-repeat left
            center;
          background-size: rem(24px) auto;
        }
      }
    }
  }
  .qa-section,
  .evaluate-section,
  .member-evaluate-section {
    .g-info {
      // padding: rem(20px) 0;
      .g-info-comment {
        position: relative;
        .g-info-comment-content {
          & > div:last-child {
            &::after {
              border: 0;
            }
          }
        }

        .comment-item:last-child::after {
          border-bottom: 0 none;
        }
      }
      .btn-bottom {
        display: block;
        margin: 0 auto rem(10px);
        width: rem(210px);
        height: rem(48px);
        font-size: rem(28px);
        color: #121212;
        line-height: rem(48px);
        text-align: center;
        @include border(all, #121212);
      }
    }
  }
  .identify-section {
    .g-info {
      .txt {
        padding: rem(30px) rem(20px);
        font-size: rem(26px);
        color: #666;
        // border-bottom: rem(1px) solid #E5E5E5;
        line-height: rem(42px);
        @include border(bottom, #e5e5e5);
      }
      .msg {
        display: flex;
        .part {
          display: flex;
          padding: rem(30px) 0 rem(30px) rem(40px);
          flex: 1;
          .icon {
            display: block;
            width: rem(80px);
            height: rem(80px);
            margin-right: rem(20px);
          }
          .icon1 {
            background: url(../../assets/images/icon1_bg.png) no-repeat;
            background-size: cover;
          }
          .icon2 {
            background: url(../../assets/images/icon2_bg.png) no-repeat;
            background-size: cover;
          }
          .name {
            flex: 1;
            p {
              padding: rem(10px) 0;
              font-size: rem(28px);
              color: #121212;
            }
            span {
              font-size: rem(24px);
              color: #999999;
            }
          }
          .icon-youjiantou {
            font-size: rem(26px);
            vertical-align: text-top;
          }

          &:last-child {
            @include border(left, #e5e5e5);
          }
        }
      }
    }
  }

  .g-right-line {
    // border-right: 1px solid #e5e5e5;
  }
  .g-section {
    margin-top: rem(20px);
    background: #ffffff;
    .g-info {
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: rem(100px);
    background-color: #fff;
    z-index: 10;
    box-shadow: 0 0 10px rgba(0, 204, 204, 0.5);
    box-shadow: 0 0 0, 0 0 0, 0 -3px 3px rgba(0, 0, 0, 0.06), 0 0 0;
    .aList {
      display: flex;
      overflow: hidden;
    }
    a {
      box-sizing: border-box;
      height: rem(100px);
      padding: rem(20px) 0;
      text-align: center;
      font-size: rem(22px);
      color: #ff397e;
    }

    .iconfont {
      margin-right: rem(10px);
      font-size: rem(48px);
      line-height: rem(50px);
    }
    .btn {
      flex: 1;
      padding: rem(10px) 0;
      .iconfont {
        margin-right: 0;
        margin-bottom: rem(10px);
        color: #666666;
      }
    }
    .pingjia {
      border-right: rem(1px) solid #dddddd;
      border-left: rem(1px) solid #dddddd;
    }
    .contactMe {
      width: rem(400px);
      font-size: rem(32px);
      background-color: #ff6ea2;
      color: #ffffff;
    }
    span {
      display: block;
      line-height: rem(30px);
      color: #121212;
    }
    .setPauid {
      display: block;
      height: rem(100px);
      background-color: #ff6ea2;
      color: #ffffff;
      font-size: rem(32px);
      text-align: center;
      line-height: rem(100px);
    }
  }
  i.pingjia {
    display: inline-block;
    width: rem(44px);
    height: rem(44px);
    background: url('~@/assets/images/icon-pingjia@3x.png') no-repeat;
    background-size: rem(44px) rem(44px);
  }
  .guw-ui {
    .g-info {
      width: auto;
      margin-left: rem(-30px);
      margin-right: rem(-30px);
      ul {
        overflow-x: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        li {
          padding-bottom: 0;
          width: auto;
          img {
            width: rem(180px);
          }
          &:first-child {
            padding-left: rem(30px);
          }
          &:last-child {
            padding-right: rem(30px);
          }
        }
      }
    }
  }
  .noPadding {
    padding-bottom: 0 !important;
  }
  .qrcode-visible {
    background: transparent;
    .qrcode-preivew {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: rem(600px);
      height: rem(739px);
      background: #ffffff;
      border-radius: rem(16px);
      & > img {
        display: block;
        width: rem(480px);
        height: rem(480px);
        margin: 0 auto;
      }
      .qrcode-name {
        line-height: rem(50px);
        font-size: rem(36px);
        color: #262626;
        text-align: center;
        font-weight: 500;
        margin-top: rem(32px);
        margin-bottom: rem(24px);
      }
      .qrcode-tip {
        line-height: rem(33px);
        font-size: rem(24px);
        color: #333333;
        text-align: center;
        font-weight: 400;
      }
    }
    .icon-close {
      display: block;
      width: rem(64px);
      height: rem(64px);
      margin: rem(50px) auto 0;
    }
  }
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';
.block-part {
  .small-block {
    .star-wrapper ul {
      padding-left: rem(52px);
      padding-top: rem(5px);
      padding-bottom: rem(5px);
    }
  }
}
.actionbar {
  @include border(top);
  .action-others {
    li {
      // @include border(right);
    }
    .iconfont {
      color: #666;
    }
  }
  .btns a {
    display: block;
    color: #fff !important;
    .iconfont {
      padding-right: rem(10px);
    }
  }
}
.signlist-section {
  .scroller-warp {
    height: rem(200px) !important;
    .ui-scroller {
      li:first-child {
        margin-left: rem(25px) !important;
      }
      li {
        position: relative;
        width: rem(200px) !important;
        height: rem(200px) !important;
        margin-left: 0 !important;
        .img-warp {
          width: rem(120px);
          height: rem(120px);
          border-radius: 50%;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          overflow: hidden;
        }
        .userTypeName {
          position: absolute;
          width: rem(120px);
          height: rem(40px);
          line-height: rem(40px);
          text-align: center;
          bottom: 0;
          left: 50%;
          font-size: rem(18px);
          color: #fff;
          background-color: rgba(0, 0, 0, 0.3);
          transform: translate(-50%, 0);
        }

        img {
          width: rem(120px);
          height: rem(120px);
          border-radius: 50%;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
        }

        .name {
          font-size: rem(28px);
          color: #121212;
          text-align: center;
          margin-top: rem(135px);
        }
      }
    }
  }
}
</style>
